import { StoredMaterialsCarryoverType } from '../enums.js'

export const DEFAULT_STORED_MATERIAL_HANDLING = StoredMaterialsCarryoverType.AUTOMATIC
